export interface UserModel {
  userType: UserTypeEnum;
  key: string;
  id: number;
  firstName: string;
  lastName: string;
  title?: string;
  emailAddress: string;
  cellPhone?: string;
  officePhone?: string;
  extension?: string;
  profilePhotoUrl?: string;
  agreeText: boolean;
  agreeEmail: boolean;
  receiveChats: boolean;
}

export enum UserTypeEnum {
  DrugRep = 1,
  StaffMember = 2,
  Admin = 3,
}

export interface EmailExistsModel {
  exists: boolean;
  message?: string;
  userType?: UserTypeEnum;
  userKey?: string;
  canDelete?: boolean;
  organizationNames?: string[];
  cannotDeleteReasons?: string[];
}

export interface UserListModel {
  userType: UserTypeEnum;
  key: string;
  id: number;
  title?: string;
  firstName: string;
  lastName: string;
  emailAddress: string;
  profilePhotoUrl?: string;
  active: boolean;
  lastLoggedInAt: string;
  createdAt: string;
  receiveChats: boolean;
  canDelete: boolean;
}

export interface SelectableUserListModel extends UserListModel {
  selected: boolean;
}
